
/* styles */
require("!!../../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-629ea680\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!../../../../../vue-loader/lib/selector?type=styles&index=0!./rtVerticalAttr.vue")

var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./rtVerticalAttr.vue"),
  /* template */
  require("!!../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-629ea680\"}!../../../../../vue-loader/lib/selector?type=template&index=0!./rtVerticalAttr.vue"),
  /* scopeId */
  "data-v-629ea680",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/business/common/rtVerticalAttr.vue
// module id = 1368
// module chunks = 91